module.exports = __webpack_public_path__ + "img/pdi3.047ee2cc.svg";